import { ObservableFromFetch } from "../ObservableFromFetch"
import ResendModel from "./Model/ResendModel"

export default function ResendInvitation(resend: ResendModel) {
    const requestBody = JSON.stringify(resend)
    return ObservableFromFetch<string>("FFOrderClinicEnrollment/ResendInvitation", requestBody)
}